module.exports = __webpack_public_path__ + "img/traffic-arbitrage.6897d9f4.png";